var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InterfaceForm',{attrs:{"form-name":_vm.formName,"title":_vm.title,"submit-button":_vm.submitButton},on:{"submit":_vm.submitHandler,"close":_vm.closeHandler}})
}
var staticRenderFns = []

export { render, staticRenderFns }